import Select from '../../../../CMSComponent/Forms/Fields/select'
import { primary_color } from '../../../../Helper/uiHelper'

const TicketAssigned = ({ field, isEditMode, setUpdatedData, defaultValue=[] }) => {
  if (isEditMode && field) {

    return (
      <Select
        data={field}
        isTable={true}
        noCache
        value={defaultValue}
        onChangeValue={(id, value) => {
        
          setUpdatedData((data) => {
            return {
              ...data,
              user_groups: value,
            }
          })
        }}></Select>
    )
  }
  return (
    <div className='d-flex flex-wrap'>
      {defaultValue?.map((item, index) => {
        return (
          <div key={index} className='badge badge-warning text-light mr-2 mb-2' style={{ background: primary_color }}>
            {item?.label}
          </div>
        )
      })}
    </div>
  )
}
export default TicketAssigned
